import React from 'react';
import './Spinner.css';

export default function SpinnerWithoutProgress() {
  return (
    <div className='spinner-container'>
      <div className='spinner'></div>
    </div>
  );
}
